import { CookieConsentActions } from "./CookiePreferences";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useAuth } from "./contexts/AuthContext/UseAuth";
import {
  CONSENT_EVENT,
  getConsent,
  identifyAnalyticsUser,
  isInternal,
  prepareAnalytics,
  trackPage,
} from "@/lib/analytics";

export default function ProductAnalytics() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    identifyAnalyticsUser(user?.profile.sub ?? null);
  }, [user?.profile.sub]);
  useEffect(() => {
    const enabled = prepareAnalytics() && !isInternal();
    setVisible(enabled);
    setOpen(enabled && getConsent() === null);
    trackPage();
    const update = () => {
      setOpen(false);
      trackPage();
    };
    window.addEventListener(CONSENT_EVENT, update);
    return () => window.removeEventListener(CONSENT_EVENT, update);
  }, [pathname]);

  if (!visible || !open) return null;
  return (
    <section
      aria-label="Analytics cookie preferences"
      className="fixed bottom-4 left-4 right-4 z-[100] max-w-md rounded-2xl border border-gray-200 bg-white p-5 text-gray-900 shadow-2xl"
    >
      <h2 className="text-base font-semibold">Help us improve Rentinit</h2>
      <p className="mt-2 text-sm leading-relaxed text-gray-600">
        Allow Google Analytics to measure visits and feature usage. When signed
        in, activity is linked to your internal account ID. Analytics is
        optional.
      </p>
      <a
        href="https://rentinit.ae/cookie-policy/"
        className="mt-2 inline-block text-sm text-brand-ink underline"
        target="_blank"
        rel="noreferrer"
      >
        How we use cookies
      </a>
      <div className="mt-4">
        <CookieConsentActions />
      </div>
    </section>
  );
}
